import moment from 'moment-timezone';

const DEFAULT_LOCALE = 'en-US';

export class DateFormatter {
  static selectedTimeZone = moment.tz.guess();

  static selectedLocale =
    typeof navigator !== 'undefined' && navigator.language
      ? navigator.language
      : DEFAULT_LOCALE;

  static initLocale() {
    if (typeof navigator !== 'undefined' && navigator.language) {
      this.selectedLocale = navigator.language;
    }
  }

  static getEffectiveTimezone() {
    const browserTz = moment.tz.guess();
    if (browserTz) {
      return browserTz;
    }
    if (!this.selectedTimeZone) {
      this.selectedTimeZone = moment.tz.guess();
    }
    return this.selectedTimeZone;
  }

  static parseDate(date) {
    if (!date) {
      return null;
    }
    const parsed = date instanceof Date ? date : new Date(date);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  static formatShort(date, showTime = true) {
    const parsed = this.parseDate(date);
    if (!parsed) {
      return '-';
    }
    const options = showTime
      ? { dateStyle: 'short', timeStyle: 'short', timeZone: this.getEffectiveTimezone() }
      : { dateStyle: 'short', timeZone: this.getEffectiveTimezone() };
    return new Intl.DateTimeFormat(this.selectedLocale, options).format(parsed);
  }

  static formatFull(date, showTime = true) {
    const parsed = this.parseDate(date);
    if (!parsed) {
      return '-';
    }
    const options = showTime
      ? {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          timeZoneName: 'long',
          timeZone: this.getEffectiveTimezone(),
        }
      : {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          timeZone: this.getEffectiveTimezone(),
        };
    return new Intl.DateTimeFormat(this.selectedLocale, options).format(parsed);
  }

  static formatDateOnly(date) {
    return this.formatShort(date, false);
  }

  static toISOString(date) {
    const parsed = this.parseDate(date);
    return parsed ? parsed.toISOString() : null;
  }

  /**
   * @deprecated Use formatShort instead
   * @param {*} date
   * @returns
   */
  static formatToUTC(date) {
    return this.formatShort(date);
  }

  /**
   *
   * @param {*} date
   * @returns
   */
  static formatToLocale(date) {
    return this.formatShort(date);
  }

  /**
   *
   * @returns
   */
  static getTimezones() {
    return moment.tz.names();
  }

  /**
   *
   * @param {*} timezone
   */
  static setTimeZone(timezone) {
    this.selectedTimeZone = timezone;
  }
}

export default DateFormatter;
